import Divider from '@mui/material/Divider';
import { ReactNode, useCallback, useState } from 'react';
import { ClosingStatus, RemoteResource } from '../../../types';

import DashboardWidgetCard from '../DashboardWidgetCard';
import IncorporationActions, { IncorporationActionsProps } from './IncorporationActions';
import IncorporationContent, { IncorporationContentProps } from './IncorporationContent';

interface IncorporationCardProps extends Omit<IncorporationActionsProps, 'disabled'> {
  title: ReactNode;
  resource: RemoteResource<ClosingStatus[]>;
  name: IncorporationContentProps['name'];
}

const IncorporationCard = ({
  title,
  resource,
  onChangeIntervalMode,
  onChangeItemMode,
  initValueItemMode,
  initValueIntervalMode,
  name,
}: IncorporationCardProps) => {
  const [itemMode, setItemMode] = useState<IncorporationContentProps['itemMode']>('error');
  const handleChangeItemMode: NonNullable<IncorporationActionsProps['onChangeItemMode']> =
    useCallback(
      value => {
        setItemMode(value);
        if (onChangeItemMode) onChangeItemMode(value);
      },
      [onChangeItemMode]
    );

  return (
    <DashboardWidgetCard title={title}>
      <IncorporationContent itemMode={itemMode} resource={resource} name={name} />
      <Divider />
      <IncorporationActions
        onChangeIntervalMode={onChangeIntervalMode}
        onChangeItemMode={handleChangeItemMode}
        initValueItemMode={initValueItemMode}
        initValueIntervalMode={initValueIntervalMode}
        disabled={false}
      />
    </DashboardWidgetCard>
  );
};

export default IncorporationCard;
